import {APIClient} from "../../api/httpClient";
import * as url from "./endpoints";

const api = new APIClient();

export const assignPoint = (establishmentId: string, emissionPointId: string) => 
    api.create(url.ASSIGN_POINT, { establishmentId, emissionPointId });
